import { getServerSession } from 'next-auth'

import AuthOptions from '@/app/api/auth/[...nextauth]/auth-options'

type User = {
  name: string
  email: string
  image: any
  id: any
  role: string
}

export const getAuthToken = async (): Promise<{
  idToken: string | null
  accessToken: string | null
  name: string | undefined
  user: User | undefined
  role: string | undefined
  strapiId: string | undefined
}> => {
  const session = await getServerSession(AuthOptions)

  // console.log('-----session-------')
  // console.log(session)
  // console.log('-----session-------')

  const idToken = session?.idToken || null
  const accessToken = session?.accessToken || null
  const name = session?.user?.name || undefined
  const user = session?.user || undefined
  const role = session?.user?.role || undefined
  const strapiId = session?.user?.strapiId || undefined

  return { idToken, accessToken, name, user, role, strapiId }
}
